import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";
import Swiper from "react-id-swiper";
import { Button } from "react-bootstrap";
import ReactResizeDetector from "react-resize-detector";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

import "../../../node_modules/react-id-swiper/src/styles/css/swiper.css";

import * as playerActions from "../../actions/playerActions";

import PlayerItem from "../playerItemComponents/PlayerItem";
import PlayerTextInput from "../playerItemComponents/PlayerTextInput";
import PlayerTextInputMultiline from "../playerItemComponents/PlayerTextInputMultiline";
import PlayerPicker from "../playerItemComponents/PlayerPicker";
import PlayerYesNo from "../playerItemComponents/PlayerYesNo";
import PlayerBarcodeScanner from "../playerItemComponents/PlayerBarcodeScanner";
import PlayerImagePicker from "../playerItemComponents/PlayerImagePicker";
import PlayerSketchpad from "../playerItemComponents/PlayerSketchpad";
import PlayerDatePicker from "../playerItemComponents/PlayerDatePicker";
import PlayerAddress from "../playerItemComponents/PlayerAddress";
import PlayerLocation from "../playerItemComponents/PlayerLocation";
import PlayerMultiChoice from "../playerItemComponents/PlayerMultiChoice";
import PlayerSingleChoice from "../playerItemComponents/PlayerSingleChoice";
import ActivityPlayerShowModeToolbar from "./ActivityPlayerShowModeToolbar";
import * as Utils from "../../utils/utils";
import VideoPreview from "../shared/videoPreview";
import ImagePreview from "../shared/imagePreview";
import PlayerCommentsModal from "./PlayerCommentsModal";
import { getUrlForValue } from "../../actions/drive";
import { getConfigParam } from "../../utils/config";
import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";

const DEFAULT_ACTIVITY_BACKGROUND = "./assets/showMode/defaultShowModeBackground2.jpg";

//Placeholder
class ActivityPlayerShowMode extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);

		let activity = this.props.activity;
		let initialSlideIndex = _.get(activity, "selected.itemIndex");

		this.state = {
			currentSlideIndex: (initialSlideIndex) ? initialSlideIndex : 0
		};
	}

	componentDidMount() {
		let self = this;

		const identityId = this.props.user.identityId;

		setTimeout(function () {
			const color = getConfigParam("fontColor", "white");
			if (color === "white") {
				document.getElementsByTagName("body")[0].className = "showMode";
			}
			const items = [];
			self.props.activity.children.forEach(list => {
				list.children.forEach(section=> {
					section.children.forEach(item => {
						items.push(item);
					});
				});
			});
			self.setState({ items });
			const index = self.state.currentSlideIndex;
			self.props.dispatch(playerActions.setItemCheckedForShowMode, 0, 0, index, identityId);
		}, 0);
	}

	componentDidUpdate() {
	
	}

	handleSaveAndExit() {
		this.props.dispatch(
			playerActions.saveActivityAndExitShowMode
		);
	}

	handleClickPlay() {
		playerActions.showVideoPreview();

		// SyntheticVoiceApi.stop();
		// this.setState({
		// 	showVideoPreview: true
		// });
	}

	handleClickImage(image) {
		playerActions.showImagePreview(this.context.tree,image);

		// SyntheticVoiceApi.stop();
		// this.setState({
		// 	showImagePreview: true
		// });
	}

	handleClickComments() {
		this.props.dispatch(
			playerActions.showComments
		);
	}
	
	handleVideoPreviewClose() {
		playerActions.hideVideoPreview();

		// this.setState({
		// 	showVideoPreview: false
		// });
	}

	handleImagePreviewClose() {
		playerActions.hideImagePreview();

		// this.setState({
		// 	showImagePreview: false
		// });
	}

	handleCommentsModalClose() {
		this.props.dispatch(
			playerActions.hideComments
		);
	}


	handleOpenInNewTab() {
		Utils.handleLaunchInNewTab();
	}

	handleReplay() {
		this.props.dispatch(
			playerActions.clearCurrentActivityNoConfirm,
			true
		);
	}

	handleOnSlideChange() {
		const identityId = this.props.user.identityId;

		if (this.swiper) {
			let index = this.swiper.activeIndex;

			this.props.dispatch(playerActions.setItemCheckedForShowMode, 0, 0, index, identityId);

			if (index > this.state.currentSlideIndex) {				
				if (this.props.onNavigateForward) {				
					this.props.onNavigateForward(0, 0, index);
				}
			} else if (index < this.state.currentSlideIndex) {
				if (this.props.onNavigateBackward) {
					this.props.onNavigateBackward(0, 0, index);
				}
			}

			this.setState({ currentSlideIndex: index });
			if (this.props.audio) {
				SyntheticVoiceApi.stop();
				const { items } = this.state;
				const item = items[index];
				const config = {
					prop: ["label1","label2"]
				};
				if (!_.isEmpty(item.video)) {
					config.extraText = ["There is an associated video."];
				}
				// let speech = textToSpeak && textToSpeak.replace ? textToSpeak.replace(/^\W*/, "") : "";
				// speech = speech ? speech : "";
				console.log("Speak new item", item);
				SyntheticVoiceApi.speakItem(item, config);
			}
		}
	}

	getItemKey(listIndex, sectionIndex, itemIndex) {
		let key = "player-list-" + listIndex + "-section-" + sectionIndex + "-item-" + itemIndex;
		return key;
	}

	render() {
		let self = this;
		let identityId = this.props.user.identityId;



		let slideItems = [];
		let activityBackground = DEFAULT_ACTIVITY_BACKGROUND;

		try {
			if (self.props.activity && self.props.activity.children) {
				const activity = self.props.activity;
				if (activity.hasOwnProperty("backgroundImage") && !_.isEmpty(activity.backgroundImage)) {
					activityBackground = getUrlForValue(activity.backgroundImage, activity.id);
				}

				self.props.activity.children.forEach((list, i) => {
					list.children.forEach((section, j) => {
						section.children.forEach((item, k) => {

							let itemVisible = Utils.isVisible(item);
							let selected = (itemVisible) ? playerActions.itemSelected(self.context.tree, i, j, k) : false;

							let component;
							if (item.type.toLowerCase() === "item") {
								component = <PlayerItem
									listIndex={i}
									sectionIndex={j}
									itemIndex={k}
									item={item}
									readOnly={!self.props.editable}
									showMode={self.props.showMode}
									useCustomShowModeStyling={activity.useCustomShowModeStyling}
									showModeTextAlign={activity.showModeTextAlign}
									onSubmit={(checked) => {
										playerActions.setItemChecked(
											self.context.tree,
											i, j, k,
											checked,
											identityId,
											item.linkOnCheck,
											item.linkId,
											item.linkActionType
										);
									}}
									onClickShowModeImage={()=>self.handleClickImage(item.image)}
									selected={selected}
								/>;
							} else if (item.type.toLowerCase() === "itemtextinput") {
								try {
									component = <PlayerTextInput
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemTextInputChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemtextinputmultiline") {
								try {
									component = <PlayerTextInputMultiline
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemTextInputChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itempicker") {
								try {
									component = <PlayerPicker
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value, linkOnSelect, linkId, linkActionType) => {
											playerActions.setItemPickerChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												linkOnSelect,
												linkId,
												linkActionType
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemyesno") {
								try {
									component = <PlayerYesNo
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onSubmit={(value) => {
											playerActions.setItemYesNoChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												item.linkOnSelect,
												item.linkActionType,
												item.linkYesId,
												item.linkNoId,
												item.linkNaId
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itembarcodescanner") {
								try {
									component = <PlayerBarcodeScanner
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemBarcodeChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemimagepicker") {
								try {
									component = <PlayerImagePicker
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										// identityId={self.props.activityIdentityId}
										identityId="No User"
										showMode={self.props.showMode}
										onChange={(value, valueUrls) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"valueUrls",
												valueUrls
											);
										}}
										onSubmit={(value, valueUrls) => {
											playerActions.setItemImagePickerAddMedia(
												self.context.tree,
												i, j, k,
												value,
												valueUrls,
												true,
												identityId
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemsketchpad") {
								try {
									component = <PlayerSketchpad
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={true}
										showMode={self.props.showMode} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemdate" || item.type.toLowerCase() === "itemtime" || item.type.toLowerCase() === "itemdatetime") {
								try {
									component = <PlayerDatePicker
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemDateChecked(
												self.context.tree,
												i, j, k,
												value,
												item.type,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemaddress") {
								try {
									component = <PlayerAddress
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemLocationChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemlocation") {
								try {
									component = <PlayerLocation
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemLocationChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemchoicemulti") {
								try {
									component = <PlayerMultiChoice
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value, choiceItem) => {
											playerActions.setItemChoiceMultiChecked(
												self.context.tree,
												i, j, k,
												value,
												choiceItem,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemchoicesingle") {
								try {
									component = <PlayerSingleChoice
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										readOnly={!self.props.editable}
										showMode={self.props.showMode}
										onChange={(value) => {
											playerActions.handleChangeProperty(
												self.context.tree,
												i, j, k,
												"value",
												value
											);
										}}
										onSubmit={(value) => {
											playerActions.setItemChoiceSingleChecked(
												self.context.tree,
												i, j, k,
												value,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}}
										selected={selected}/>;
								} catch (e) {
									console.error(e);
								}
							}

							//TODO: Does visible logic belong outside component?

							let itemComponent = null;
							let key = self.getItemKey(i, j, k);
							if (Utils.isVisible(item)) {
							
								itemComponent = <div key={key} id={key} style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
									<div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%" }}>
										{component}
									</div>
								</div>;


								slideItems.push({ index: k, item: item, component: itemComponent });
							}
						});

					});
				});
			}
		} catch (e) {
			console.error(e);
			alert(e.message);
		}
		

		const params = {
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: false
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			},
			spaceBetween: 0,
			on: {
				slideChange: self.handleOnSlideChange
			}

		};

		let currentItem = slideItems[this.state.currentSlideIndex].item;

		let hasImage = Utils.itemHasImage(currentItem);
		let hasVideo = Utils.itemHasVideo(currentItem);
		let videoPlayer;
		let imagePreview;



		if (hasVideo) {			
			videoPlayer = <VideoPreview videoUri={currentItem.video} onClickClose={this.handleVideoPreviewClose} isOpen={this.props.showVideoPreview}/>;			
		}

		if (hasImage) {
			imagePreview = <ImagePreview imageUri={currentItem.image} onClickClose={this.handleImagePreviewClose} isOpen={this.props.showImagePreview} />;
		}

		let playerCommentsModal = <PlayerCommentsModal listIndex={0} sectionIndex={0} itemIndex={this.state.currentSlideIndex} onClickClose={this.handleCommentsModalClose} isOpen={this.props.showComments} />;

		let slideItemComponents = slideItems.map((item, idx) => {		
			return <div key={"slide-" + idx} className="player-show-mode-item-container">	
				{item.component}
			</div>;
		});

		let swiper = <Swiper containerClass="player-show-mode-swiper swiper-container" {...params} ref={node => { if (node) { this.swiper = node.swiper; } }} initialSlide={this.state.currentSlideIndex} threshold={12}>			
			{slideItemComponents}			
		</Swiper>;

		const color = getConfigParam("fontColor", "white");

		const showHeaderPanel = getConfigParam("showHeaderPanel", true);
		const iframe = Utils.isInIFrame();

		const style = {
			width: "100%", height: "100%", overflow: "hidden", display: "flex", flexDirection: "column", position: "absolute", top: "0", left: "0", backgroundColor: "#000000", color
		};


		const backgroundColor = getConfigParam("backgroundColor", null);

		if (backgroundColor && activityBackground === DEFAULT_ACTIVITY_BACKGROUND) {
			style.backgroundColor = backgroundColor;
			style.backgroundImage = "none";
		} else {
			style.backgroundImage = `url("${activityBackground}")`;
		}

		if (showHeaderPanel && iframe) {
			style.paddingTop = "50px";
		}
		
		return (
			<div className="player-show-mode" style={style}>
				{iframe && showHeaderPanel && <div style={{ position: "fixed", top: 0, left: 0, width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0,.8)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<div style={{ color: "white", fontWeight: 600, fontSize: "11px", paddingLeft: "10px", fontFamily:"'Roboto Condensed', sans-serif"}}>Powered By<br /><a href="https://www.ambifi.com"><img src="./ambifi-logo-powered-by.png" alt="AmbiFi Logo" style={{ width: "78px", height: "25px", marginLeft: "-5px" }} /></a></div>
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingRight: "10px" }}>
						<Button title="Reset and restart" onClick={this.handleReplay} ><FontAwesomeIcon icon="repeat"/></Button>	
						<Button title="Play in new tab" style={{ marginLeft: "5px" }} onClick={this.handleOpenInNewTab} ><FontAwesomeIcon icon="external-link"/></Button>
					</div>
				</div>}
				<ReactResizeDetector handleWidth handleHeight onResize={this.onResize} />
				{swiper}
				<div style={{position: "absolute", width: "100%", bottom: "20px", zIndex: "1"}}>
					<ActivityPlayerShowModeToolbar showPlayButton={hasVideo} showComments={currentItem.comments !== ""} onClickClose={this.handleSaveAndExit} onClickPlay={this.handleClickPlay} onClickComments={this.handleClickComments}/>
				</div>
				{videoPlayer}
				{imagePreview}
				{playerCommentsModal}
			</div>
		);
	}
	onResize(width, height) {
		this.setState({
			width,
			height
		});
	}
}

ActivityPlayerShowMode.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	showImagePreview: ["appState","showImagePreview"],
	showVideoPreview: ["appState","showVideoPreview"],
	audio: ["appPreferences", "voice","audio"],
	user: ["user"],
	showComments: ["player", "showComments"],
	inlineShowMode: ["appState","inlineShowMode"]
}, ActivityPlayerShowMode);